import PageHeader from "components/PageHeader";
import useSetTabTitle from "hooks/useSetTabTitle";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const title = "Вакансии";

  useSetTabTitle(title);

  return (
    <PageHeader
      title={title}
      mainButtonProps={{
        buttonText: "Создать вакансию",
        onClick: () => navigate("create"),
      }}
    />
  );
};

export default Header;
